<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <div :class="['row']">
                    <div :class="['col-lg-12', 'col-md-12']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >
                            <div :class="['card-body', 'pt-2']">
                                <h3 :class="['card-title', 'text-left', 'font-weight-bold', 'pb-0', 'mb-3']">Convocatorias</h3>
                                <hr :class="['mt-1', 'mb-3']">

                                <div :class="['row']">
                                    <div v-for="(val, key) in Convocatorias" :key="key" :class="['col-lg-4']">
                                        <div class="card shadow mt-3" style="height:320px;">
    							            <div class="card-body pb-1">
                                                <p class="w-100 " :class="[(val.fecha_publicacion_inicio>=fecha_actual() && val.fecha_publicacion_fin<=fecha_actual())?'bg-success':((fecha_actual()<=val.fecha_fin_proceso)?'bg-warning':'bg-danger')]" style="height: 0.5rem; "> </p> 
                                                <h6 class="text-white p-1" :class="[(val.fecha_publicacion_inicio>=fecha_actual() && val.fecha_publicacion_fin<=fecha_actual())?'bg-success':((fecha_actual()<=val.fecha_fin_proceso)?'bg-warning':'bg-danger')]" :title="val.titulo" :alt="val.titulo" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-size:14px;"><b>{{val.titulo}}</b></h6>
                                                <p class="card-text text-justify " style="text-transform:capitalize; font-size:15px;" v-html=" (((val.contenido_text).length)>230)?(((val.contenido_text)).slice(0, 230)+'...'):val.contenido_text"></p>
                                                <p class="mb-0" style="font-size:13px;">
                                                    <b><i :class="['fa', 'fa-calendar', 'mr-2']"></i>De {{val.fecha_publicacion_inicio_es}} al {{val.fecha_fin_proceso_es}}</b>
                                                </p>
                                                <router-link :to="'convocatoria_nombramiento/'+val.id" class="btn btn-link btn-sm stretched-link "></router-link> <!-- NO borrar - link funcional--> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    export default {
        name: 'Convocatorias_nombramiento',
        components:{
        },
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Convocatorias Nombramiento || "+(this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM";
            this.getConvocatorias();
        },
        data(){
            return{
                id: (this.$route.params.id)?this.$route.params.id:1,
                Anio:[],
                formSearch:{
                    anio: (new Date()).getFullYear(),
                    mes:this.str_pad(((new Date()).getMonth()+1), 2, '0', 'STR_PAD_LEFT'),
                },
                Convocatorias:[],
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            getConvocatorias(){
                this.setLoading(true);
                this.$http.get('webserviceserver/convocatorias_nomb').then((res)=>{
                    this.Convocatorias = res.data.Announcement;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>

<style scoped>
</style>